import { MetricLabelsConfiguration } from "../../Molecules/Configurations/AdvancedMetrics/MetricsLabelsConfiguration";
import { SystemLabelConfiguration } from "../../Molecules/Configurations/AdvancedMetrics/SystemLabelsConfiguration";
import { ItemsConfigurations } from "../../Molecules/Configurations/ItemsConfigurations/ItemsConfigurations";
import { MetricsConfigurations } from "../../Molecules/Configurations/Metrics/MetricsConfigurations";
import { SelectMetricLabelsConfiguration } from "../../Molecules/Configurations/Metrics/SelectMetricsConfigurations";
import { UsersConfigurations } from "../../Molecules/Configurations/UsersConfigurations/UsersConfigurations";
import { WidgetConfigurations } from "../../Molecules/Configurations/WidgetConfigurations";

export const ConfigurationsSubTabs = [
  {
    name: "Users",
    label: "users",
    path: "#users",
    submenus: null,
    component: UsersConfigurations
  },
  {
    name: "Items",
    label: "items",
    path: "#items",
    submenus: null,
    component: ItemsConfigurations
  },
  {
    name: "Widgets",
    label: "widgets",
    path: "#widgets",
    buttons: ['Widget Configurations'],
    component: [WidgetConfigurations],
    submenus: null
  },
  {
    name: "Metrics",
    label: "metrics",
    path: "#metrics",
    buttons: ['Select Metric Labels', 'Metrics Configurations'],
    component: [SelectMetricLabelsConfiguration, MetricsConfigurations],
    submenus: null
  },
  {
    name: "Advanced Metrics",
    label: "advancedMetrics",
    path: "#advancedMetrics",
    submenus: null,
    buttons: ['Metric Labels Configuration', 'System Label Mapping Configuration'],
    component: [MetricLabelsConfiguration, SystemLabelConfiguration]
  },
]